import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/image.png';
import _imports_1 from '../../assets/image/zanon.png';
import _imports_2 from '../../assets/image/zan.png';
import _imports_3 from '../../assets/image/colleon.png';
import _imports_4 from '../../assets/image/colle.png';
import _imports_5 from '../../assets/image/comment.png';
import _imports_6 from '../../assets/image/fencomment.png';
const _withScopeId = n => (_pushScopeId("data-v-2be7d3f4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tk-box-comment flex-between"
};
const _hoisted_2 = {
  class: "tk-comment-info"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看图解", -1));
const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = {
  key: 0,
  src: _imports_1,
  alt: ""
};
const _hoisted_7 = {
  key: 1,
  src: _imports_2,
  alt: ""
};
const _hoisted_8 = {
  key: 0,
  src: _imports_3,
  alt: ""
};
const _hoisted_9 = {
  key: 1,
  src: _imports_4,
  alt: ""
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "分享", -1));
const _hoisted_13 = [_hoisted_11, _hoisted_12];
import { useRoute } from "vue-router";

import { useRouter } from 'vue-router';
import { ref, reactive, toRefs, onMounted } from 'vue';
export default {
  __name: 'comment',
  props: {
    dataInfo: {
      type: Object,
      default: {}
    },
    typeId: {
      type: String,
      default: ""
    },
    corpusTypeId: {
      type: String,
      default: ""
    }
  },
  emits: ["majoFun", "hanladClick"],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const router = useRouter();
    let scrollTabs = ref(null);
    let scroolData = reactive({
      offsetTop: 0
    });
    let {
      offsetTop
    } = toRefs(scroolData);
    onMounted(() => {
      // 获取 DOM 元素
      scroolData.offsetTop = scrollTabs.value?.clientHeight;
    });

    //功能区域
    let majoFun = index => {
      emits("majoFun", index);
    };
    let commentOpne = () => {
      if (props.typeId == "") {
        emits("hanladClick");
      } else {
        router.push({
          path: "/materials/list/comment",
          query: {
            typeId: props.typeId,
            id: props.dataInfo.id,
            corpusTypeId: props.corpusTypeId
          }
        });
      }
    };
    // 是否可以前进
    const route = useRoute();
    const showTipsbs = ref(false);
    onMounted(async () => {
      if (localStorage.getItem("label") || route.query.label) {
        showTipsbs.value = true;
      } else {
        showTipsbs.value = false;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "tk-main-comment ccc",
        ref_key: "scrollTabs",
        ref: scrollTabs,
        style: _normalizeStyle({
          bottom: _unref(showTipsbs) ? '58px' : '0px'
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "tk-comment-splik",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(commentOpne) && _unref(commentOpne)(...args))
      }, "想说点什么..."), _createElementVNode("div", _hoisted_2, [__props.typeId == 1 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tk-info-item",
        onClick: _cache[1] || (_cache[1] = $event => _unref(majoFun)(4))
      }, _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "tk-info-item",
        onClick: _cache[2] || (_cache[2] = $event => _unref(majoFun)(0))
      }, [__props.dataInfo.isFollow || __props.dataInfo.follow ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : (_openBlock(), _createElementBlock("img", _hoisted_7)), _createElementVNode("span", null, _toDisplayString(__props.dataInfo.thumbUpCount), 1)]), __props.typeId == '11' || __props.typeId == '1' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "tk-info-item",
        onClick: _cache[3] || (_cache[3] = $event => _unref(majoFun)(3))
      }, [__props.dataInfo.isCollect || __props.dataInfo.collect ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : (_openBlock(), _createElementBlock("img", _hoisted_9)), _createElementVNode("span", null, _toDisplayString(__props.dataInfo.collectCount), 1)])) : (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "tk-info-item",
        onClick: _cache[4] || (_cache[4] = $event => _unref(majoFun)(1))
      }, [_hoisted_10, _createElementVNode("span", null, _toDisplayString(__props.dataInfo.commentCount), 1)])), _createElementVNode("div", {
        class: "tk-info-item",
        onClick: _cache[5] || (_cache[5] = $event => _unref(majoFun)(2))
      }, _hoisted_13)])])], 4);
    };
  }
};